// A component to display warning when SpeechRecognition is not available or when using unsupported mobile browsers
import { useTranslation } from "../hooks/useTranslation";
import { useAppStore } from "../store/appStore";

export const SpeechRecognitionStatus = () => {
  const isSpeechRecognitionAvailable = useAppStore(state => state.isSpeechRecognitionAvailable);
  const isUnsupportedMobile = useAppStore(state => state.isUnsupportedMobileBrowser);
  const t = useTranslation();
  
  // Don't show anything if speech recognition is available and not using an unsupported mobile browser
  if (isSpeechRecognitionAvailable && !isUnsupportedMobile) {
    return null;
  }
  
  // Message for browsers that don't support speech recognition
  if (!isSpeechRecognitionAvailable) {
    return (
      <div className="p-3 mb-2 bg-amber-50 dark:bg-amber-900 border border-amber-200 dark:border-amber-700 text-amber-700 dark:text-amber-300 rounded-lg">
        <div className="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" role="img" aria-label="Warning icon">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <strong>{t.speechRecognitionNotAvailable}</strong>
        </div>
        <p className="mt-1 ml-7 text-sm">{t.speechRecognitionNotAvailableDesc}</p>
        <p className="mt-1 ml-7 text-sm">
          <a 
            href="https://caniuse.com/speech-recognition" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline text-amber-700 dark:text-amber-300 hover:text-amber-800 dark:hover:text-amber-200"
          >
            {t.learnMore}
          </a>
        </p>
      </div>
    );
  }
  
  // Message specifically for iPhone Safari and Android Chrome
  if (isUnsupportedMobile) {
    return (
      <div className="p-3 mb-2 bg-blue-50 dark:bg-blue-900 border border-blue-200 dark:border-blue-700 text-blue-700 dark:text-blue-300 rounded-lg">
        <div className="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" role="img" aria-label="Info icon">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <strong>{t.unsupportedMobileBrowserWarning}</strong>
        </div>
        <p className="mt-1 ml-7 text-sm">{t.unsupportedMobileBrowserWarningDesc}</p>
        <p className="mt-1 ml-7 text-sm">
          <a 
            href="https://caniuse.com/speech-recognition" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline text-blue-700 dark:text-blue-300 hover:text-blue-800 dark:hover:text-blue-200"
          >
            {t.learnMore}
          </a>
        </p>
      </div>
    );
  }
  
  return null;
};